export default "__VITE_ASSET__RAwOtkzR__"